export const TASK_STATUSES = ['todo', 'next', 'in_progress', 'blocked', 'done', 'cancelled'] as const;
export type TaskStatus = typeof TASK_STATUSES[number];

export interface StatusMeta { label: string; color: string; order: number; }

export const STATUS_META: Record<string, StatusMeta> = {
  todo:        { label: 'Todo',        color: '#636b88', order: 0 },
  next:        { label: 'Do Next',     color: '#38bdf8', order: 1 },
  in_progress: { label: 'In Progress', color: '#6366f1', order: 2 },
  blocked:     { label: 'Blocked',     color: '#ef4444', order: 3 },
  done:        { label: 'Done',        color: '#22c55e', order: 4 },
  cancelled:   { label: 'Cancelled',   color: '#636b88', order: 5 },
};

export function statusLabel(s: string): string { return STATUS_META[s]?.label ?? s; }
export function statusColor(s: string): string { return STATUS_META[s]?.color ?? '#636b88'; }
